import type React from 'react'

interface Step {
  complete?: boolean
  label: React.ReactNode
  classes?: string
  icon?: React.ReactNode
}

interface StepperVerticalProps {
  steps: Step[]
}

function IconItem({ step, isLast }: { step: Step; isLast: boolean }) {
  const complete = step.complete
  return (
    <li className={`relative flex gap-4 ${isLast ? '' : 'min-h-28 pb-6'} ${step.classes ?? ''}`}>
      {!isLast && (
        <span
          aria-hidden="true"
          className={`absolute left-6 top-14 bottom-2 w-px -translate-x-1/2 ${complete ? 'bg-forest' : 'bg-gray-stroke'}`}
        />
      )}
      <div
        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-xl ${complete ? 'bg-forest text-white' : 'bg-mint-25 text-forest'}`}
      >
        {complete ? <i className="fa-solid fa-check" aria-hidden="true" /> : step.icon}
      </div>
      <div className="flex-1 pt-2">{step.label}</div>
    </li>
  )
}

function BulletItem({ step }: { step: Step }) {
  return (
    <li className={`relative border-l border-gray-stroke pb-4 pl-6 ${step.classes ?? ''}`}>
      {step.complete ? (
        <i className="absolute -left-2 top-1 rounded-full fa-solid fa-circle-check text-forest bg-white"></i>
      ) : (
        <i className="absolute -left-2 top-1 rounded-full fa-regular fa-circle text-forest bg-white"></i>
      )}
      {step.label}
    </li>
  )
}

export function StepperVertical({ steps }: StepperVerticalProps) {
  // biome-ignore-start lint/suspicious/noArrayIndexKey: step list is static and will not change
  return (
    <ul className="text-base text-charcoal-75 font-medium">
      {steps.map((step, index) =>
        step.icon ? (
          <IconItem key={index} step={step} isLast={index === steps.length - 1} />
        ) : (
          <BulletItem key={index} step={step} />
        )
      )}
    </ul>
  )
  // biome-ignore-end lint/suspicious/noArrayIndexKey: step list is static
}
